import { Component, Input } from '@angular/core';
import { Office } from 'app/core/models/office.model';
import { MatIcon } from '@angular/material/icon';
import { ProviderCallLogsComponent } from '../provider-call-logs/provider-call-logs.component';
import { InboundCallLogComponent } from '../inbound-call-log/inbound-call-log.component';
import { OfficeOutboundFaxesComponent } from '../office-outbound-faxes/office-outbound-faxes.component';

@Component({
    selector: 'app-office-communications',
    templateUrl: './office-communications.component.html',
    styleUrls: ['./office-communications.component.scss'],
    imports: [MatIcon, ProviderCallLogsComponent, InboundCallLogComponent, OfficeOutboundFaxesComponent]
})
export class OfficeCommunicationsComponent {
  @Input() office: Office;

  constructor(
  ) {}
}
